import domain from "../domain";
import { useState, useEffect, useRef } from "react";
import Feedback from "./Feedback";
import classes from "./FeedbackDisplayArea.module.css";
import {
  sortFeedbackDataBranchwise,
  getActiveBranchIds,
} from "../util/multipleBranch/getActiveBranchId";

//Parent component Admin Dashboard
export default function FeedbackDisplayArea({ data, feedbackIndex }) {
  //console.log("re rendering feedback dipslya area");
  /** CHECK IPAD for logic of implementing branch button press handler to
   * go to first feedback of that particular branhc
   */
  const [counterEditable, setCounterEditable] = useState(false);
  let c1 = useRef();
  let c = document.getElementById("counterInput");

  let length = useRef(0);
  if (data == null) length.current = 0;
  else length.current = data.length;

  const activeBranches = getActiveBranchIds(
    JSON.parse(localStorage.getItem("branches"))
  );

  let data2 = sortFeedbackDataBranchwise(data, activeBranches);

  //this state tracks if user want to edit count value ie which feedback to see
  let data1;
  if (data2 != null) data1 = [...data2];

  if (counterEditable) {
    //console.log("counter is editable");

    c.focus();
    c.select();
  }
  const [counter, setCounter] = useState(0);
  let ctr = 0;
  //const [currentFeedback, setCurrentFeedback] = useState(data[0]);

  //declaring state to keep track bookMaring
  let bmStatus;

  if (data1?.length > 0) {
    bmStatus = data1[counter]?.bookMarked;
    if (bmStatus != true) bmStatus = true;
  }
  const [isMarked, setIsMarked] = useState(bmStatus);
  useEffect(() => {
    setCounter(0);
  }, [data]);

  // useEffect(() => {
  //   setCounter(0);
  // }, [data1]);

  // this below if cannot be put on top, otherwise hooks will give error

  if (data == undefined || data.length == 0 || data1 == undefined) {
    return "No Data";
  }
  function nextHandler() {
    let c = document.getElementById("counterInput");
    ctr += 1;
    //console.log(ctr);
    setCounter((prev) => {
      if (counter < data1.length - 1) {
        //console.log(c.value);
        c.value = prev + 2;
        return (prev += 1);
      } else return prev;
    });
  }

  function prevHandler() {
    let c = document.getElementById("counterInput");
    //console.log("prev pressed");

    //console.log(counter);
    setCounter((prev) => {
      if (counter > 0) {
        c.value = prev;
        return (prev -= 1);
      } else return prev;
    });
  }

  function feedbackCounterHandler(e) {
    let value = e.target.value;

    let numOfFeedbacks = data.length;

    if (value > 0 && value <= numOfFeedbacks) {
      setCounter(value - 1);
    } else if (value >= numOfFeedbacks) {
      e.target.value = numOfFeedbacks;
    } else if (value < 1) {
      e.target.value = 1;
    }
  }
  function editCounterHandler(e) {
    setCounterEditable(true);
    e.preventDefault();

    //console.log("i m clikced");
    c1.current.select();
    c1.current.focus();
  }

  function onClickEditableCounter() {
    // setCounterEditable(false);
    //console.log("ddd");
    c1.current.select();
    c1.current.focus();
  }
  function onBlurEditableCounter() {
    setCounterEditable(false);
  }

  // function inputFocusHandler(e) {
  //   let c = document.getElementById("counterInput");
  //   console.log(e.target.value);
  //   c.select();
  // }
  let fixedCounterNumber = (
    <a
      className={`${counterEditable ? classes.hidden : "feedbackNumber"}`}
      href=""
      onClick={editCounterHandler}
    >
      {counter + 1}
    </a>
  );
  let editatebleCounterNumber = (
    <input
      ref={c1}
      onClick={onClickEditableCounter}
      onBlur={onBlurEditableCounter}
      className={`${
        !counterEditable ? classes.hidden : "feedbackNumberEditableMode"
      }`}
      id="counterInput"
      type="number"
      defaultValue={counter + 1}
      onChange={feedbackCounterHandler}
    />
  );

  // BELow is code to take care of BookMaring

  function bookmarkLocalHandler(id, isbm) {
    // this function updated bookMarked status of feedbacks locally in session storage.

    setIsMarked((prev) => !prev);
    // this above state change is not used but important for feedback form rendering again on change of status
    data1[counter].bookMarked = isbm;

    // making change in main data stored in session storage.
    const d1 = JSON.parse(sessionStorage.getItem("mainData"));

    d1.forEach((item) => {
      if (item._id == id) {
        item.bookMarked = isbm;
      }
    });
    // storing the upadated mainData into sessionStorage.
    sessionStorage.setItem("mainData", JSON.stringify(d1));
    bookMarkHandler(id, isbm);
  }

  // below function is to make changed to DB for BookMarking\
  function bookMarkHandler(id, isMarked) {
    //console.log("bm handler");
    // isMarked is boolean and will update the status in DB as it is.
    // this function makes changed at two places.. 1. in DB and 2 in Data stored in session storage.
    // in session storage also . change has to be made in two object main data and sub data.

    // phase 1 making update in DB.
    fetch(`${domain}/api/save`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, isMarked }),
    })
      .then((response) => {
        //console.log("then case");
        //console.log(response);

        // Now we make changes locally once change is made in DB.

        return response.json();
      })

      .catch((err) => {
        //console.log("catch case");
        //console.log(err);
      });
  }

  function branchBrowser(id) {
    let ind = 0;

    if (feedbackIndex == undefined) return null;
    feedbackIndex.forEach((obj) => {
      if (obj.bId == id) ind = obj.index;
    });

    if (ind >= data.length) ind--;
    setCounter(ind);
  }
  // function toggleBookMark() {
  //   //this function turns icon of bookmark to on or off and then this calls bookmarkHandler()
  //   console.log(isMarked);
  //   setIsMarked((prev) => !prev);
  // }

  return (
    <div className={classes.container}>
      {length.current > 1 && <h1>Feedbacks</h1>}
      {length.current > 1 && (
        <div className={classes.feedbackNumberContainer}>
          {fixedCounterNumber}
          {editatebleCounterNumber} <p>out of {data1.length}</p>
        </div>
      )}

      <div className={classes.innerContainer}>
        {length.current > 1 && (
          <div id="changeFeedback" className={classes.changeFeedback}>
            <a onClick={prevHandler} className={classes.previous}>
              &#8249;
            </a>
            <a onClick={nextHandler} className={classes.previous}>
              &#8250;
            </a>
          </div>
        )}

        <Feedback
          data={data2[counter]}
          branchBrowser={branchBrowser}
          bmHandler={bookmarkLocalHandler}
        />
      </div>
    </div>
  );
}
